// extracted by mini-css-extract-plugin
export default {"width_sec":"style_width_sec__ePP3c"};